


































































import Vue from "vue";
import { Coordinates } from "common";
import { List, OrderedMap } from "immutable";
import { Explanation, ILegOfJourney } from "../utility/explanation";

export default Vue.extend({
    name: "galaxy-map",

    props: ["blackholes", "exits", "explanation"],

    methods: {},

    computed: {
        explLegs(): List<ILegOfJourney> {
            if (!this.explanation) {
                return List([]);
            } else {
                return (this.explanation as Explanation).legs();
            }
        },

        bhs(): Coordinates[] {
            const bhs: Coordinates[] = this.blackholes;

            let last = "";
            return List(bhs)
                .sortBy(it => it.toString())
                .filter(it => {
                    const result = it.toString() !== last;
                    last = it.toString();
                    return result;
                })
                .toArray();
        },

        exs(): Coordinates[] {
            const exs: Coordinates[] = this.exits;

            let last = "";
            return List(exs)
                .sortBy(it => it.toString())
                .filter(it => {
                    const result = it.toString() !== last;
                    last = it.toString();
                    return result;
                })
                .toArray();
        },
    },
});
